module.exports = __webpack_public_path__ + "media/bootstrap-icons/pen-fill-3f5fd2b5.svg";